<template>
  <v-card>
    <v-card-title>
        Adicionar um combustível
    </v-card-title>
    <v-container flex>
      <v-form lazy-validation v-model="valid" ref="formCombustivel">
        <v-layout row wrap fill-height justify-space-between>
            <v-flex xs12>
                <v-text-field
                  label="Nome"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  v-model="dadosCombustivel.nome"
                  required
                >
                </v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-text-field
                  label="Referência"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  v-model="dadosCombustivel.ref"
                  required
                >
                </v-text-field>
            </v-flex>
            <v-flex sm12>
              <v-select
                :items="icones"
                v-model="dadosCombustivel.icone"
                label="Icone"
                single-line
              >
                <template slot="selection" slot-scope="data">
                  <v-flex xs2>
                    <v-avatar color="grey" size="25px">
                      <img :src="require(`@/assets/combs/${data.item.value}.svg`)" />
                    </v-avatar>
                  </v-flex>
                  <v-flex class='ml-1'>
                    {{ data.item.text }}
                  </v-flex>
                </template>
                <template slot="item" slot-scope="data">
                  <v-list-tile-avatar color="grey">
                    <img :src="require(`@/assets/combs/${data.item.value}.svg`)" />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </v-select>
            </v-flex>
            <v-flex xs12>
              <strong>Escolha uma cor base:</strong>
              <swatches v-model="dadosCombustivel.color" inline/>
            </v-flex>
            <v-flex xs12>
                <v-text-field
                  label="Tipo do volume"
                  hint="Exemplo: 'L' para Litros"
                  v-model="dadosCombustivel.tipo_volume"
                >
                </v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-text-field
                  label="Descrição do volume"
                  hint="Exemplo: 'Litros' para o tipo de volume L"
                  v-model="dadosCombustivel.descricao_volume"
                >
                </v-text-field>
            </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-card-actions>
        <v-btn flat color="info" @click="fechar()">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat color="info" @click="inserirCombustivel()">Confirmar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { combustivelDao } from '@/api'
import Swatches from 'vue-swatches'

export default {
  components: { Swatches },
  data () {
    return {
      valid: false,
      dadosCombustivel: {
        nome: null,
        icone: null,
        color: null,
        descricao: null,
        tipo_volume: null,
        descricao_volume: null,
        ref: null
      },
      icones: [
        {
          text: 'Álcool',
          value: 'alcool'
        },
        {
          text: 'Gasolina',
          value: 'gas'
        },
        {
          text: 'Gás Natural',
          value: 'gasnatural'
        },
        {
          text: 'Diesel',
          value: 'diesel'
        },
        {
          text: 'Diesel S10',
          value: 'S10'
        }
      ]
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    }
  },
  methods: {
    fechar () {
      this.$refs.formCombustivel.reset()
      this.$emit('fechar')
    },
    inserirCombustivel () {
      if (this.$refs.formCombustivel.validate()) {
        combustivelDao.insert(this.dadosCombustivel, this.headers)
          .then(response => {
            if (response.ok) {
              this.$emit('info', 'Combustível adicionado com sucesso')
              this.fechar()
            } else {
              this.$emit('error', 'Não foi possível adicionar o combustivel')
              this.fechar()
            }
          })
      }
    }
  }
}
</script>
